import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import handleOpenWhatsApp from 'services/whatsappService';
import { SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL } from '../data/assets';

const AreYouReady = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant={'h2'}
        gutterBottom
        align={'center'}
        marginBottom={'2rem'}
      >
        ¿Listo para mover tu marca con nosotros?
      </Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 600 }}
        variant={'h4'}
        gutterBottom
        align={'center'}
        marginBottom={'2rem'}
        color="textSecondary"
      >
        Forma parte de Marketing en Movimiento y conecta con emprendedores, marketers y decisores que invierten en estrategia, tecnología y crecimiento real. Hagamos que tu propuesta sea el próximo insight que la audiencia aplica en su negocio.
      </Box>

      <Grid container spacing={4}>
        <Grid item container alignItems={'center'} xs={12} md={6}>
          <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
            <Box marginBottom={2}>
              <Typography
                variant="h5"
                color="textPrimary"
                sx={{
                  fontWeight: 700,
                }}
              >
                Patrocinio, segmentos, entrevistas, TNO Digest, cápsulas y UGC: tu marca en el ecosistema donde el marketing no se queda quieto.
              </Typography>
            </Box>
            <Box marginBottom={3}>
              <Typography
                variant="body1"
                component="p"
                color="textSecondary"
                sx={{ fontWeight: 400 }}
              >
                Marketing en Movimiento, con Loyola Rosales y Luzmey Hernández. Contenido que impulsa negocios.
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretched', sm: 'flex-start' }}
            >
              <Button
                component={'a'}
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMd ? false : true}
                onClick={handleOpenWhatsApp}
                target={'_blank'}
              >
                Patrocinar Marketing en Movimiento
              </Button>
              <Box
                marginTop={{ xs: 2, sm: 0 }}
                marginLeft={{ sm: 2 }}
                width={{ xs: '100%', md: 'auto' }}
              >
                <Button
                  component={'a'}
                  href={'https://www.tnonetwork.com/show/marketingenmovimiento'}
                  variant="outlined"
                  color="primary"
                  size="large"
                  fullWidth={isMd ? false : true}
                >
                  Ver el programa
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            height={'100%'}
            width={'100%'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Box height={'100%'} width={'100%'} maxHeight={600}>
              <Box
                component="img"
                src={SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL}
                alt="Marketing en Movimiento — TNO Network"
                sx={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: 600,
                  objectFit: 'contain',
                  borderRadius: 2,
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Marketing en Movimiento: Estrategia que no se detiene.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
